//
// File: ShellContext.tsx
// Description: Provides a context for the shell to expose user information to the application
// TODO: Is this actually still needed?
// Copyright: Broadlume 2024
//

import * as React from 'react';
import { Context, createContext } from 'react';

/**
 * Concrete type for the ShellContext
 */
export type ShellContextType = {
  getUserName: () => string;
};

/**
 * The shell context
 */
export const ShellContext: Context<unknown> = createContext<unknown>({});

/**
 * The ShellProvider is a wrapper component that provides the ShellContext to its children
 * @param children - The children to wrap with the Provider
 * @returns A ShellContext.Provider react component
 */
export const ShellProvider = ({ children } : {children : React.ReactNode}) => {
  const [userName, setUserName] = React.useState('Guest');

  const userProvider = {
    getUserName: () : string => {
      return userName
    }
  };

  return <ShellContext.Provider value={{userProvider}}>{children}</ShellContext.Provider>;
};

/*
 * A hook to access the shell context
 */
 export const useShell = () => {
  return React.useContext(ShellContext);
};